import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { title } from 'styles/texts'
import { gray } from 'styles/colors'
import { border } from 'styles'
import { firstTimeChatVisitSelector } from 'selectors'
import { visit } from 'actions'

import RoomWrapper from './RoomWrapper'
import Button from 'components/Button'

const Wrapper = styled.div`
  flex-shrink: 0;
  border-right: ${border};
  width: 420px;
  display: flex;
  flex-direction: column;
`

const Heading = styled.div`
  ${title};
  padding: 25px 0;
  text-align: center;
  border-bottom: ${border};
`

const List = styled.div`
  overflow-y: auto;
  flex-grow: 1;
`

const Welcome = styled.div`
  margin: 80px auto 0;
  max-width: 200px;
  text-align: center;
  color: ${gray};

  & > img {
    margin-bottom: 20px;
  }
`

class Rooms extends React.Component {
  state = {
    page: 1,
  }

  componentWillUnmount() {
    this.props.visit('chat')
  }

  render() {
    const {
      className,
      heading,
      roomIds,
      activeRoom,
      selectRoom,
      firstTimeVisit,
    } = this.props
    return (
      <Wrapper className={className}>
        {heading && <Heading>Samtaler</Heading>}
        <List>
          {roomIds
            .filter((_, i) => i < this.state.page * 10)
            .map(roomId => (
              <RoomWrapper
                key={roomId}
                roomId={roomId}
                active={roomId === activeRoom}
                onClick={() => selectRoom(roomId)}
              />
            ))}
          {firstTimeVisit && (
            <Welcome>
              <span
                style={{
                  display: 'inline-block',
                  fontSize: 50,
                  marginBottom: 20,
                }}
                role="img"
                aria-label="chat bubble">
                💬
              </span>
              <div>Her samles alle dine samtaler med andre brukere av Spir.</div>
            </Welcome>
          )}
          {this.state.page * 10 < roomIds.length && (
            <Button
              onClick={() =>
                this.setState(({ page }) => ({
                  page: page + 1,
                }))
              }>
              Last flere
            </Button>
          )}
        </List>
      </Wrapper>
    )
  }
}

const mapStateToProps = state => ({
  firstTimeVisit: firstTimeChatVisitSelector(state),
})

const mapDispatchToProps = { visit }

export default connect(mapStateToProps, mapDispatchToProps)(Rooms)



// WEBPACK FOOTER //
// ./src/components/chat/Rooms.js